import { Field } from 'formik';
import { FsProps, CustomSelectComponent, FormCol6 } from 'motion-components';
import React from 'react';

/** enum('P909','P908','P911') — collection_orders_xrb.packagingTypeCode */
export const FieldSelectPackagingTypeCode = ({
  label = 'Τύπος Διαθέσιμης Συσκευασίας',
  name = 'xrbData.packagingTypeCode',
  as = FormCol6,
  ...rest
}: FsProps) => {
  const options = [
    { value: 'P909', label: 'P909' },
    { value: 'P908', label: 'P908' },
    { value: 'P911', label: 'P911' },
  ];
  return (
    <Field
      name={name}
      title={label}
      component={(props) => <CustomSelectComponent {...props} as={as} className="mb-0 p-0" />}
      options={options}
      useCreatableSelect={true}
      {...rest}
    />
  );
};
